import { createSelector } from 'reselect';
import { SITES } from '../constants/site.constants';
import { initialState } from '../reducers/site.reducer';

const selectState = state => state?.[SITES] || initialState;

const selectSitesData = createSelector(
  selectState,
  state => state.get('data')
);

export const selectSites = createSelector(
  selectSitesData,
  data => data.toList()
);

export const selectSelectedSite = createSelector(
  selectState,
  state => state.get('selectedSite')
);